import { render, staticRenderFns } from "./MostLovedSpots.vue?vue&type=template&id=8010d8d0"
import script from "./MostLovedSpots.vue?vue&type=script&lang=js"
export * from "./MostLovedSpots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports